// @flow

import React, { type Node } from 'react';
import styled, {css} from 'styled-components';
import { HighlightBox, SectionTitle, Padding } from '../atoms';
import { useIsMobile } from '@tectonics/hooks';

type TipModel = {
  imgSrc: string,
  tipText: Node,
  altText: string,
};

type TipsBoxProps = {
  title: string,
  tipsModel: ImmutableArray<TipModel>,
};

export function TipsBox({ title, tipsModel }: TipsBoxProps): Node {
  const isMobile = useIsMobile();

  return (
    <HighlightBox bordered>
      <Padding value="1em">
        <SectionTitle>{title}</SectionTitle>
        <Section>
          {tipsModel.map(({ imgSrc, tipText, altText }, index) => (
            <Tip key={index} maxWidth={isMobile ? '100%' : '400px'}>
              <TipIcon src={imgSrc} alt={altText} />
              <TipText>{tipText}</TipText>
            </Tip>
          ))}
        </Section>
      </Padding>
    </HighlightBox>
  );
}

const Section = styled.section`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 16px;
`;

const Tip = styled.div`
  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const TipIcon = styled.img`
  flex: 0 0 auto;
  height: 100%;
`;

const TipText = styled.p`
  color: ${props => props.theme.colors.neutral[900]};
  font-size: 12px;
  margin-left: 8px;
`;
